import React, { useEffect, useState } from 'react';
// import { NewsSection, NewsItem } from './styles'; // ajoute les styles qu'on a définis
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';
import { NewsSection, NewsSlide,StyledSwiper, NewsContent,SeeMoreLink } from './styles'; // styled-components
import { BASE_API_URL_ENDPOINT, BASE_API_DOCUMENT } from '../../api/Api';
import { getNewsTypeString } from '../../helpers/constant';
import { Link } from 'react-router-dom'; // si tu utilises react-router
import axios from "axios";


const NewsScroller = () => {
  const [news, setNews] = useState([]);

  useEffect(() => {
    // Remplace par ton appel API réel ici
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL_ENDPOINT}news`); // Exemple d'endpoint
        setNews(response.data.data.slice(0, 4));
      } catch (error) {
        console.error("Erreur de chargement des actualités :", error);
      }
    };

    fetchNews();
  }, []);

  return (
    <NewsSection>
      <h2>Dernières actualités</h2>
      <StyledSwiper
        modules={[Autoplay]}
        autoplay={{ delay: 4000, disableOnInteraction: false }}
        loop={true}
        centeredSlides={true}
        slidesPerView={'auto'}
        spaceBetween={20}
      >
        {news.map((item) => (
          <SwiperSlide key={item.id} style={{ width: '80%' }}>
            <NewsSlide image={`${BASE_API_DOCUMENT}${item.image}`}>
              <NewsContent>
                <h3>{item.title}</h3>
                <h4>{getNewsTypeString(item.category)}</h4>
                <p>{item.excerpt.slice(0, 100)}...</p>
                <SeeMoreLink to={`/news/${item.id}`}>Voir plus</SeeMoreLink>
              </NewsContent>
            </NewsSlide>
          </SwiperSlide>
        ))}
      </StyledSwiper>
    </NewsSection>
  );
};

export default NewsScroller;
